export default function CTASection() {
  return (
    <section className="relative w-full h-[420px] md:h-[500px] overflow-hidden">
      {/* Background */}
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20with%20smartphone%20on%20coffee%20table%2C%20soft%20natural%20light%20streaming%20through%20window%2C%20comfortable%20sofa%2C%20plant%20decor%2C%20lifestyle%20photography%2C%20warm%20orange%20and%20cream%20tones%2C%20relaxed%20atmosphere%2C%20no%20people%20visible&width=1800&height=900&seq=cta-bg-51chigua&orientation=landscape"
        alt="下载51吃瓜APP"
        title="51吃瓜网站APP下载"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <h2 className="text-3xl md:text-5xl font-heading text-background-50 font-black tracking-wide mb-4">
          随时随地 想瓜就瓜
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-8 max-w-md leading-relaxed">
          下载51吃瓜APP，第一时间获取最新爆料推送
          <br className="hidden sm:block" />
          不错过任何一个大瓜
        </p>
        {/* Pill button with orange accent */}
        <button className="group relative flex items-center gap-3 bg-primary-600 text-background-50 pl-1 pr-5 py-2 rounded-full text-sm font-semibold hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer">
          <span className="w-10 h-10 bg-accent-500 rounded-full flex items-center justify-center flex-shrink-0">
            <i className="ri-download-2-line text-lg text-background-50"></i>
          </span>
          <span>立即下载APP</span>
          <i className="ri-arrow-right-up-line text-background-50/60 group-hover:text-background-50 transition-colors"></i>
        </button>
      </div>
    </section>
  );
}